/* istanbul ignore file */
import {
  Checkbox,
  Flex,
  Icon,
  type IconNames,
  StyledMultiSelectV2 as Select,
  Text,
  Tooltip,
  styled,
} from '@kandji-inc/nectar-ui';
import {
  CheckedValues,
  type DeviceFilter,
  NextCheckedValues,
} from './DeviceFamilyFilter.types';

const StyledListBoxItem = styled(Select.ListBoxItem, {
  gap: '$1',
});

export interface DeviceFilterItemProps {
  updateFilters: (id: string, value: string) => void;
  filter: DeviceFilter;
  asChild?: boolean;
  tooltip?: {
    content: React.ReactNode;
    icon: IconNames;
    color?: string;
  };
}

export function DeviceFilterItem({
  updateFilters,
  filter,
  asChild = false,
  tooltip,
}: DeviceFilterItemProps) {
  return (
    <StyledListBoxItem
      isDisabled={filter.disabled}
      onAction={() => updateFilters(filter.id, NextCheckedValues[filter.value])}
      key={filter.label}
      aria-label={filter.label}
      // TODO: Multiply padding by nested level
      css={{
        paddingLeft: asChild ? 32 : '$3',
        cursor: filter.disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <Checkbox
        disabled={filter.disabled}
        checked={CheckedValues[filter.value]}
      />
      <Flex gap="xs" alignItems="center">
        <Flex justifyContent="center" alignItems="center" css={{ width: 18 }}>
          <Icon name={filter.icon} size="sm" />
        </Flex>
        <Text variant={filter.disabled ? 'secondary' : 'default'}>
          {filter.label}
        </Text>
        {tooltip && (
          <Tooltip
            content={tooltip.content}
            theme="light"
            css={{ zIndex: 999999, padding: '12px 16px', minWidth: '300px' }}
          >
            <Flex css={{ height: 12 }}>
              <Icon name={tooltip.icon} size="xs" color={tooltip.color} />
            </Flex>
          </Tooltip>
        )}
      </Flex>
    </StyledListBoxItem>
  );
}
